// extracted by mini-css-extract-plugin
export default {"wrap":"SlideUp_wrap__rwlDz"};